/**
 * Creates a virtual a link that, using pdf base64 forces browser to download the provided pdf.
 *
 * @param pdf_base64_content Pdf content in base 64 format.
 * @param file_name Name of the file when downloaded.
 */
import {htmlToPdf} from "./requests/RequestsPDFs";

export function downloadPdf(pdf_base64_content, file_name = 'pdf_file.pdf') {
    const downloadLink = document.createElement("a");
    downloadLink.href = 'data:application/pdf;base64,' + pdf_base64_content;
    downloadLink.download = file_name;
    downloadLink.click();
}

/**
 * Throws a request to convert html provided to pdf, and forces the browser to download it.
 *
 * @param html_content
 * @param file_name
 */
export async function downloadHtmlAsPdf(html_content, file_name = 'pdf_file.pdf') {
    let pdf_content = await htmlToPdf(html_content);
    return downloadPdf(pdf_content, file_name);
}
